// The static author site lives entirely in public/index.html (plain HTML/CSS/vanilla JS, no build step).
// This React root intentionally renders nothing so it never overlaps that markup.
function App() {
  return null;
}

export default App;
